import axiosService from './AxiosService';

export class AddressService {
   _resourceName = 'address';

   async getSavedAddresses() {
      return await axiosService.readObject(`/v1.0/${this._resourceName}`);
   }

   async deleteSavedAddress(position) {
      return await axiosService.delete(`/v1.0/${this._resourceName}`, position);
   }

   static get instance() { return addressService }
}

const addressService = new AddressService();

export default addressService;
